import React, { useEffect, useState } from "react";
import { fetchApiPost } from "../utils/FetchApi";
import { ApiName } from "../utils/ApiName";
import EasyPaisaLandig from "../pages/EasyPaisaLandig";
import { useSearchParams } from "react-router-dom";
import tagManagerEvents from "../utils/GoogleTagManager";

type Props = {
  token: string | null;
};

const EasyPaisaLandigScreen = (props: Props) => {
  const [phoneNo, setPhoneNo] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [timer, setTimer] = useState(30);
  const [seconds, setSeconds] = useState(30);
  const [isHidden, setIsHidden] = useState(true);
  const [isChecked, setIsChecked] = useState(true);
  const [isFromParams, setIsFromParams] = useState(false);

  const [isResendClicked, setResendClicked] = useState(false);
  const [otp, setOtp] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });

  const [inputRef, setInputRef] = useState<React.RefObject<HTMLInputElement>[]>(
    [
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
      React.createRef<HTMLInputElement>(),
    ]
  );
  const [searchParams] = useSearchParams();

  const usermsisdn = searchParams.get("usermsisdn");
  const walletmsisdn = searchParams.get("walletmsisdn");
  const utm_source: any = searchParams.get("utm_source");
  const parameter = searchParams.get("parameter") ?? "";
  const utm_campaign = searchParams.get("utm_campaign") ?? "";

  useEffect(() => {
    if (walletmsisdn && usermsisdn && props.token) {
      setIsFromParams(true);
      onDecrypt(walletmsisdn);
    }
  }, [walletmsisdn, usermsisdn, props.token]);

  useEffect(() => {
    if (isResendClicked) {
      setSeconds(30);
      setResendClicked(false);
    }

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(interval);
        }
        return prevSeconds > 0 ? prevSeconds - 1 : 0;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isResendClicked]);

  useEffect(() => {
    let interval: string | number | NodeJS.Timeout | undefined;
    if (timer > 0) {
      interval = setTimeout(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => clearTimeout(interval);
  }, [timer]);

  const handlePhoneNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isFromParams) return;
    let value = e.target.value;
    if (!value || (value.length <= 10 && value.match(/^3\d{0,9}$/))) {
      setShowError(false);
      setPhoneNo(e.target.value);
      setOtp({
        one: "",
        two: "",
        three: "",
        four: "",
      });
      if (value.length === 10) {
        tagManagerEvents("Ep_Number_Punched", utm_source);
        sendOTP(e.target.value, false);
      }
    }
  };

  // decrypt

  const onDecrypt = async (phoneNo: string) => {
    let data = {
      msisdn: phoneNo,
    };
    try {
      let response = await fetchApiPost(
        props.token,
        ApiName.epDecrypt,
        data,
        true
      );
      if (response.result) {
        tagManagerEvents("Ep_Number_Punched", utm_source);
        setPhoneNo(response.result.slice(-10));
        sendOTP(response.result, true);
      }
    } catch (err) {
      setShowError(true);
      setErrorMsg("Something went wrong, Please try again.");
    }
  };

  const sendOTP = async (phoneNo: string, organic: boolean) => {
    let data = {};
    if (organic) {
      data = {
        enc_msisdn: walletmsisdn,
      };
    } else {
      data = {
        msisdn: phoneNo,
      };
    }
    const endpoint = organic
      ? ApiName.epGenerateOtpOrganic
      : ApiName.epGenerateOtp;
    try {
      let response = await fetchApiPost(props.token, endpoint, data);
      if (response.code === 0) {
        tagManagerEvents("Ep_Otp_Send", utm_source);
      } else {
        setShowError(true);
        setErrorMsg("Unable to send OTP, Please try again.");
      }
    } catch (err) {
      setShowError(true);
      setErrorMsg("Something went wrong, Please try again.");
    }
  };

  // --------------- APIs ---------------

  const handleChangeOTP = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    let otpEntered = e.target.value;
    setShowError(false);

    if (!isNaN(otpEntered as any) && otpEntered !== " ") {
      setOtp({
        ...otp,
        [e.target.name]: otpEntered,
      });
      if (e.target.value.length === 1) {
        const nextInput = inputRef[index + 1];
        if (nextInput?.current) {
          nextInput.current.focus();
        }
      }
    } else {
      setShowError(true);
      setErrorMsg("Please enter a valid OTP");
    }
  };
  // backspace button
  const handleBackspace = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ): void => {
    if (e.keyCode === 8) {
      setShowError(false);
      const target = e.target as HTMLInputElement;
      if (target.value.length === 0 && index !== 0) {
        (inputRef[index - 1].current as HTMLInputElement).focus();
      }
    }
  };

  const onResendOtpPressed = async () => {
    setTimer(30);
    setResendClicked(true);
    setOtp({
      one: "",
      two: "",
      three: "",
      four: "",
    });
    sendOTP(phoneNo, isFromParams);
  };

  const onVerifyPressed = () => {
    if (isChecked) {
      let checkOTP = otp.one + otp.two + otp.three + otp.four;
      const endPoint = isFromParams
        ? ApiName.epVerifyLinkOtpOrganic
        : ApiName.epVerifyLinkOtp;

      let data = {};
      if (isFromParams) {
        data = {
          msisdn: usermsisdn,
          enc_msisdn: walletmsisdn,
          otp: checkOTP,
          source: utm_source,
          sub_source:parameter
        };
      } else {
        data = {
          msisdn: phoneNo,
          otp: checkOTP,
          source: utm_source,
          sub_source:parameter
        };
      }

      VerifyLinkOtp(endPoint, data);
    } else {
      setShowError(true);
      setErrorMsg("Please accept the terms and conditions to proceed.");
    }
  };

  const VerifyLinkOtp = async (endpoint: string, data: any) => {
    try {
      setShowLoader(true);
      let response = await fetchApiPost(props.token, endpoint, data);
      if (response.code === 0) {
        setIsHidden(false);
        setShowLoader(false);
        tagManagerEvents("Ep_Subscribe", utm_source);
      } else {
        tagManagerEvents("Ep_Subscription_Failed", utm_source);
        setShowLoader(false);
        setShowError(true);
        setErrorMsg(
          response.message || "Unable to subscribe, Please try again."
        );
      }
    } catch (error) {
      tagManagerEvents("Ep_Subscription_Failed", utm_source);
      setShowLoader(false);
      setShowError(true);
      setErrorMsg("Unable to subscribe,Please try again.");
    }
  };

  const handleOverLay = () => {
    setIsHidden(true);
  };
  const onPressCheckBox = () => {
    setIsChecked(!isChecked);
  };
  return (
    <EasyPaisaLandig
      showLoader={showLoader}
      errorMsg={errorMsg}
      showError={showError}
      phoneNo={phoneNo}
      otp={otp}
      isChecked={isChecked}
      seconds={seconds}
      isHidden={isHidden}
      parameter={parameter}
      utm_campaign={utm_campaign}
      onPressCheckBox={onPressCheckBox}
      onVerifyPressed={onVerifyPressed}
      handleChangeOTP={handleChangeOTP}
      handleBackspace={handleBackspace}
      onResendOtpPressed={onResendOtpPressed}
      inputRef={inputRef}
      handlePhoneNoChange={handlePhoneNoChange}
      handleOverLay={handleOverLay}
    />
  );
};

export default EasyPaisaLandigScreen;
